import {FC, useEffect, useState} from 'react'
import {PageLink} from '../../../_metronic/layout/core'
import {KTCard} from '../../../_metronic/helpers'
import { useLocation, useParams} from 'react-router-dom'
import { Vulnerability } from './Vulnerability'
import { VulnerabilitiesPageTitle } from '_metronic/layout/core/vulnerabilitiesPageData'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const VulnerabilityWrapper: FC = () => {
  const [activeTab, setActiveTab] = useState('vendor-risk')
  const location = useLocation()
  const {id} = useParams()

  useEffect(() => {
    // Fetch control data when the component mounts
    if (location.pathname.includes('archive')) {
      setActiveTab('archive')
    } else if (location.pathname.includes('available')) {
      setActiveTab('available')
    } else {
      setActiveTab('vendor-risk')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return (
    <>
      <VulnerabilitiesPageTitle
        icon='VendorIcon.svg'
        title='Assets'
        desc={
          'Identify, track, and remediate security vulnerabilities across your assets to reduce risk and maintain compliance.'
        }        
        breadcrumbs={usersBreadcrumbs}
      />
      <KTCard>
        <Vulnerability />
      </KTCard>
    </>
  )
}

export default VulnerabilityWrapper
